module.exports = __webpack_public_path__ + "img/40_38_040_310.2224c656.jpg";